// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation_wrapper__1x3Vo","navItem":"Navigation_navItem__2a0HX","navLink":"Navigation_navLink__sv7vx","navLinkActive":"Navigation_navLinkActive__1bPwj"};